
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/otevrena-lyzarska-strediska",
      function () {
        return require("private-next-pages/[region]/otevrena-lyzarska-strediska.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/otevrena-lyzarska-strediska"])
      });
    }
  